import React, { useState } from 'react';
import axios from 'axios';
import '../App.css'; // Global styles

function Register() {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        role: 'user', // Default role is 'user'
        secret: '', // Admin secret for secure role assignment
    });
    const [message, setMessage] = useState('');
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            setMessage('Пароль не подходит.');
            return;
        }

        try {
            const response = await axios.post(`${API_URL}/api/auth/register`, {
                email: formData.email,
                password: formData.password,
                role: formData.role, // Pass the selected role
                secret: formData.role === 'administrator' ? formData.secret : undefined, // Pass the secret only for admin role
            });

            // Check for successful response
            if (response.status === 200 || response.status === 201) {
                setMessage(response.data.message || 'Успешно! Можете войти.');
            } else {
                setMessage('Неожиданная ошибка.');
            }
        } catch (error) {
            console.error('Error:', error);

            // Display error details if available
            if (error.response && error.response.data && error.response.data.message) {
                setMessage(error.response.data.message);
            } else {
                setMessage('Ошибка регистрации. Пожалуйста, попробуйте позже.');
            }
        }
    };

    return (
        <div className="register-form">
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                />
                <input
                    type="password"
                    name="password"
                    placeholder="Пароль"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                />
                <input
                    type="password"
                    name="confirmPassword"
                    placeholder="Подтвердите пароль"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    required
                />
                <select
                    name="role"
                    value={formData.role}
                    onChange={handleInputChange}
                    required
                >
                    <option value="user">Пользователь</option>
                    <option value="viewer">Гость</option>
                    <option value="administrator">Администратор</option>
                </select>
                {formData.role === 'administrator' && (
                    <input
                        type="password"
                        name="secret"
                        placeholder="Введите секретный ключ"
                        value={formData.secret}
                        onChange={handleInputChange}
                        required
                    />
                )}
                <button type="submit">Регистрация</button>
            </form>
            {message && <p>{message}</p>}
        </div>
    );
}

export default Register;
